var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateCopyOfferCodeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M21,8a3,3,0,0,0-3-3H10A3,3,0,0,0,7,8V20a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3ZM19,8a1,1,0,0,0-1-1H10A1,1,0,0,0,9,8V20a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Z",
    fill: "#00a5f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M6,3H16a1,1,0,0,0,0-2H6A3,3,0,0,0,3,4V18a1,1,0,0,0,2,0V4A1,1,0,0,1,6,3Z",
    fill: "#00a5f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateCopyOfferCodeIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-copy-offer-code-icon.76d487c8ba066ca77c2e46fc6e10c92f.svg";
export { ForwardRef as ReactComponent };